import React from "react";

function DropDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
    >
      <path d="M480-360L280-560h400L480-360z"></path>
    </svg>
  );
}

export default DropDown;
